import allowEditSelfComment from '@/helpers/allow-edit-self-comment';
import { Button } from '@repo/ui/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@repo/ui/components/ui/dropdown-menu';
import { Review } from '@repo/ui/models/candidate';
import { Ellipsis } from 'lucide-react';
import React from 'react';

export type SelfCommentModel = Review & { formattedDate: string };

export type SelfCommentProps = {
  comment: SelfCommentModel;
  onEditClick: () => void;
};

const SelfComment: React.FC<SelfCommentProps> = ({ comment, onEditClick }) => {
  const allowEditComment = comment
    ? allowEditSelfComment(comment.createdAt)
    : true;

  return (
    <div className="flex flex-col items-center justify-center gap-2 w-full py-2">
      <div className="flex justify-between w-full">
        <div className="flex gap-1 items-center">
          <span className="text-sm font-semibold">{comment.jury}</span>
          <span className="text-sm font-light">{comment.formattedDate}</span>
        </div>
        {allowEditComment && (
          <div>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="text-muted-foreground">
                  <Ellipsis />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="-mt-3 mr-14">
                <DropdownMenuItem
                  className=" cursor-pointer"
                  onClick={onEditClick}
                >
                  Edit Comment
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        )}
      </div>
      <div className="pr-4 flex justify-start w-full">{comment.comment}</div>
    </div>
  );
};

export default SelfComment;
